import { Observable, Subject } from 'rxjs';
import { EventKey } from '../../common/enums/event-key';
import { filter } from 'rxjs/operators';

export interface EventsOption<T> {
  key: EventKey;
  data?: T;
}

export class Events {
  private static eventSub = new Subject<EventsOption<any>>();
  public static event$: Observable<EventsOption<any>> =
    Events.eventSub.asObservable();

  public static emit<T>(event: EventsOption<T>): void {
    this.eventSub.next(event);
  }

  public static on<T>(key: EventKey): Observable<EventsOption<T>> {
    return Events.event$.pipe(
      filter((event: EventsOption<T>) => event.key === key)
    );
  }
}
